import moment from 'moment'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { compose } from 'redux'
import CustomPrimeTable, { DEFAULT_PAGE_SAZE } from '../../common/PrimeTable/CustomPrimeTable'
import useContactUrl from '../../hooks/useContactUrl'
import camelToSnake from '../../utils/camelToSnake'
import { getDataForRecentCalls } from '../ClickToCall/Redux/clickToCallActions'
import { formatDuration } from './utils'

const CallsTable = ({
  history,
  getDataForRecentCalls,
  recentCallsData,
  recentCallsQuery,
  dateFilter,
  userId,
  callDuration,
  callStatus,
}) => {
  const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }
  const [options, setOptions] = useState({
    pagination: DEFAULT_PAGINATION,
    sort: {},
    filter: {
      creation_date: dateFilter,
      created_by: userId,
      callDuration,
      utcOffset: moment().utcOffset(),
      status: callStatus,
    },
    tableFilter: {},
  })
  // const [date, setDate] = useState({ end_time: null, start_time: null })

  const { getUrl } = useContactUrl()

  useEffect(() => {
    getDataForRecentCalls(options)
  }, [options])

  const onFilterChange = async (event) => {
    let tableFilter = {}
    Object.keys(event.filters).forEach(function (key) {
      tableFilter[camelToSnake(key)] = event.filters[key].value
    })
    setOptions({
      ...options,
      tableFilter,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const onSortChange = async (event) => {
    let sort = {}

    if (event.multiSortMeta) {
      event.multiSortMeta.map((row) => {
        sort[row.field] = row.order
      })
    }

    setOptions({
      ...options,
      sort,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const onPageChange = async (event) => {
    await history.push({
      pathname: history.location.pathname,
      search: `?first=${event.first}&limit=${event.rows}`,
    })

    const pagination = queryString.parse(history.location.search)
    setOptions({
      ...options,
      pagination,
    })
  }

  // const onCalendarChange = (e, name) => {
  //   setDate({ ...date, [name]: e.value })
  //   if (e.value[1]) {
  //     setOptions({
  //       ...options,
  //       tableFilter: {
  //         ...options.tableFilter,
  //         [name]: { start: e.value[0], end: e.value[1] },
  //       },
  //       pagination: DEFAULT_PAGINATION,
  //     })
  //   }
  // }

  const userBody = (rowData) => {
    return <div>{rowData.users.name}</div>
  }

  const contactLink = (rowData) => {
    return <Link onClick={() => window.open(getUrl(rowData.contacts), '_blank')}>{rowData.contacts.name}</Link>
  }

  const notesBody = (rowData) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: rowData.notes,
        }}
      />
    )
  }

  const activityBody = (rowData) => {
    return (
      <div>
        {rowData.activityData.name}
        {rowData.transferred && (
          <span className='ml-2' title='Call was transferred'>
            <i className='fas fa-exchange-alt' style={{ color: '#007bff' }} />
          </span>
        )}
      </div>
    )
  }

  const pbxIdBody = (rowData) => {
    return <div style={{ textAlign: 'center' }}>{rowData.pbxId || rowData.pbx_id || '-'}</div>
  }

  const durationBody = (rowData) => {
    const duration = rowData.duration || 0
    const formattedDuration = formatDuration(duration)
    return <div style={{ textAlign: 'center' }}>{formattedDuration}</div>
  }

  const columns = [
    {
      field: 'creationDate',
      header: 'Date',
      style: { textAlign: 'center' },
      format: 'MM-DD-YYYY',
    },
    { field: 'createdBy', header: 'User', style: { textAlign: 'center' }, body: userBody },
    { field: 'contactId', header: 'Contact', style: { textAlign: 'center' }, body: contactLink },
    { field: 'numberOfTrucks', header: 'Trucks', style: { textAlign: 'center' } },
    {
      field: 'st.id',
      header: 'Activity',
      style: { textAlign: 'center' },
      body: activityBody,
    },
    { field: 'pbxId', header: 'Pbx ID', style: { textAlign: 'center' }, body: pbxIdBody },
    { field: 'duration', header: 'Duration', style: { textAlign: 'center' }, body: durationBody },
    { field: 'notes', header: 'Notes', style: { textAlign: 'center' }, body: notesBody },
  ]

  return (
    <>
      <CustomPrimeTable
        data={recentCallsData}
        columns={columns}
        addHidden={true}
        onFilter={onFilterChange}
        onSort={onSortChange}
        onPage={onPageChange}
        query={recentCallsQuery}
        showActions={false}
      />
    </>
  )
}

CallsTable.propTypes = {
  recentCallsData: PropTypes.array,
  recentCallsQuery: PropTypes.object,
}

CallsTable.defaultProps = {
  recentCallsData: [],
  recentCallsQuery: {},
}

const mapStateToProps = (state) => {
  return {
    recentCallsData: state.ClickToCall.recentCallsData.data,
    recentCallsQuery: state.ClickToCall.recentCallsData.query,
  }
}

export default compose(withRouter, connect(mapStateToProps, { getDataForRecentCalls }))(CallsTable)
